const tableLabels = {
    testimonies: '見證分享',
    sermons: '講台信息',
    news: '教會消息',
    redirects: '導向網址',
    pastor_messages: '牧者的話',
    page_content_2: '網頁內容',
    fellowship_schedules: '聚會時間',
    devotion_sharings: '靈修分享',
    bible_study_materials: '查經資料',
    articles: '標竿刊物',
};

module.exports = tableLabels;